import PropTypes from 'prop-types';

const contentCategoryCardType = PropTypes.shape({
  title: PropTypes.string,
  coverImage: PropTypes.string,
  coverVideo: PropTypes.string,
  url: PropTypes.string,
  assetId: PropTypes.string,
  assetUrl: PropTypes.string,
});

const videoLandingPayloadType = PropTypes.shape({
  pnpVideoUrl: PropTypes.string,
  trendingSearchTerms: PropTypes.arrayOf(
    PropTypes.shape({
      term: PropTypes.string.isRequired,
      url: PropTypes.string.isRequired,
    })
  ).isRequired,
  hero: PropTypes.shape({
    showSubscriptionBanner: PropTypes.bool,
    coverVideo: PropTypes.string,
    boardUrl: PropTypes.string,
  }),
  contentCategories: PropTypes.shape({
    establishing: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string,
        coverImage: PropTypes.string,
        coverVideo: PropTypes.string,
        url: PropTypes.string,
      })
    ),
    featured: PropTypes.arrayOf(contentCategoryCardType),
    inspiredPills: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
      })
    ),
    popularVideoSearches: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string,
        title: PropTypes.string,
        url: PropTypes.string,
      })
    ),
  }),
  faq: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string,
      answer: PropTypes.string,
    })
  ),
  faqHtml: PropTypes.string,
  faqSchema: PropTypes.shape({
    '@context': PropTypes.string,
    '@type': PropTypes.string,
    mainEntity: PropTypes.arrayOf(
      PropTypes.shape({
        '@type': PropTypes.string,
        name: PropTypes.string,
        acceptedAnswer: PropTypes.shape({
          '@type': PropTypes.string,
          text: PropTypes.string,
        }),
      })
    ),
  }),
  heroHtml: PropTypes.string,
  categoryTilesPillsHtml: PropTypes.string,
  popularVideoSearchesHtml: PropTypes.string,
});

export default videoLandingPayloadType;
